import { startCase } from "lodash";

const titleCase = (str) => startCase(str.toLowerCase());

export default titleCase;
